(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yunlore-header"]) return;
  try {
    
  function initYunLoreCartCount() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || bubble.dataset.countReady) return;
    bubble.dataset.countReady = 'true';
    const updateCount = () => {
      const count = bubble.querySelector('.yl-cart-count')?.textContent.trim() || '0';
      document.querySelectorAll('[data-yl-cart-count]').forEach((node) => { node.textContent = count; });
    };
    new MutationObserver(updateCount).observe(bubble, { childList: true, subtree: true, characterData: true });
    updateCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initYunLoreCartCount);
  else initYunLoreCartCount();
  document.addEventListener('shopify:section:load', initYunLoreCartCount);

  function initYunLoreBannerHeader() {
    if (!document.body.classList.contains('template-index')) return;
    const header = document.querySelector('.yl-header-section');
    const hero = document.querySelector('[data-yl-cinema]');
    if (!header || !hero || header.dataset.bannerBoundaryReady) return;
    header.dataset.bannerBoundaryReady = 'true';
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const height = header.offsetHeight;
      const offset = Math.min(0, hero.getBoundingClientRect().bottom - height);
      header.style.transform = 'translate3d(0,' + offset + 'px,0)';
      const offscreen = offset <= -height;
      header.inert = offscreen;
      const menu = header.querySelector('details');
      if (offscreen && menu) menu.open = false;
    };
    const schedule = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    const observer = new ResizeObserver(schedule);
    observer.observe(hero);
    observer.observe(header);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initYunLoreBannerHeader);
  else initYunLoreBannerHeader();
  document.addEventListener('shopify:section:load', initYunLoreBannerHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yunlore-home"] && !Shopify.designMode) return;
  try {
    
  function initYunLoreCinema() {
    document.querySelectorAll('[data-yl-cinema]').forEach((hero) => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const video = hero.querySelector('video');
      if (!video) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let inView = true;
      let playPending = false;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      if (video.dataset.desktopSrc) {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const preferredSource = mobile && video.dataset.mobileSrc ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (video.getAttribute('src') !== preferredSource) video.src = preferredSource;
        video.preload = reducedMotion.matches ? 'none' : 'auto';
      }
      const requestPlayback = () => {
        playPending = true;
        video.play().then(() => {
          playPending = false;
        }).catch(() => { playPending = false; });
      };
      const syncPlayback = () => {
        if (document.hidden || reducedMotion.matches || !inView) {
          video.autoplay = false;
          video.pause();
          return;
        }
        video.autoplay = true;
        if (video.paused && !playPending) requestPlayback();
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { inView = entry.isIntersecting; syncPlayback(); });
      }, { threshold: 0 });
      observer.observe(hero);
      video.addEventListener('canplay', syncPlayback);
      video.addEventListener('canplaythrough', syncPlayback);
      video.addEventListener('progress', syncPlayback);
      video.addEventListener('loadeddata', syncPlayback);
      document.addEventListener('visibilitychange', syncPlayback);
      reducedMotion.addEventListener('change', syncPlayback);
      const resumeOnGesture = (event) => {
        if (document.hidden || reducedMotion.matches || !inView || event.target.closest('a, button, summary')) return;
        video.muted = true;
        video.autoplay = true;
        requestPlayback();
      };
      hero.addEventListener('touchend', resumeOnGesture, { passive: true });
      hero.addEventListener('click', resumeOnGesture);
      syncPlayback();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initYunLoreCinema, { once: true });
  else initYunLoreCinema();
  document.addEventListener('shopify:section:load', initYunLoreCinema);

  } catch(e) { console.error(e); }
})();
})();
